import React from 'react';
import { Link } from 'react-router-dom';
import blogs from '../../api/blogs';

const BlogSection = () => {
	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section className='bg-[#f5f5f5] pt-[94px] pb-[70px]'>
			<div className='wraper'>
				<div className='col-span-12 text-center'>
					<div className='mb-[60px]'>
						<span className='text-[16px] text-[#ada282]'>Actualités</span>
						<h2
							className=" text-[36px] md:text-[26px] font-medium text-[#333] pb-[20px] 
                       relative before:absolute before:content-[''] before:left-[50%] before:bottom-0 
                       before:transform before:-translate-x-1/2 before:w-[60px] before:h-[3px] before:bg-[#c0b596]"
						>
							Dernières News
						</h2>
					</div>
				</div>
				<div className='grid grid-cols-12 gap-4'>
					{blogs.map((blog, bl) => (
						<div className='col-span-4 md:col-span-6 col:col-span-12' key={bl}>
							<div className='mb-[30px] group'>
								<div className='transition ease-in-out duration-300'>
									<img
										className='w-full transition ease-in-out duration-300 group-hover:grayscale'
										src={blog.newsCoverImg}
										alt=''
									/>
								</div>
								<div className='bg-white pt-[20px] px-[20px] pb-[30px]'>
									<h3 className='text-[24px] leading-[36px] font-heading-font font-medium mb-[20px] !text-left'>
										<Link
											onClick={ClickHandler}
											to={`/news/${blog.slug}`}
											className='text-[#000] transition ease-in-out duration-300 hover:text-[#c0b596]'
										>
											{blog.title}
										</Link>
									</h3>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default BlogSection;
